var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfoTooltip(_ref) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    color: "#948F8A",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 17,
    height: 17,
    rx: 8.5,
    fill: "currentColor"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.073 5.81a.962.962 0 01-.952-.952c0-.532.434-.966.952-.966.532 0 .966.434.966.966a.965.965 0 01-.966.952zM6.657 9.114C7.707 7.35 8.73 6.818 9.415 6.818c1.022 0 .812 1.022.546 1.806l-1.26 3.78c-.238.7-.322 1.036 0 1.036.252 0 .854-.616 1.47-1.652l.168.084c-.98 1.75-2.03 2.296-2.646 2.296-.756 0-1.036-.476-.588-1.806l1.26-3.766c.196-.56.378-1.05.056-1.05-.35 0-.91.588-1.596 1.652l-.168-.084z",
    fill: "#fff"
  })));
}
export default SvgInfoTooltip;